<div>
    <app-tool-bar [title]="'Pipeline Configuration'" [iconName]="'pi-sitemap'" [isAdd]="true"
        (handleAdd)="handleAddPipeline()">
    </app-tool-bar>
</div>

<div class="p-4 overflow-auto h-[85vh]">
    <p-tabs [value]="activeTabIndex.toString()" (onChange)="onTabChange($event)" class="pipeline-tabs">
        <p-tablist>
            <p-tab *ngFor="let tab of tabs; let i = index" [value]="i.toString()">{{ tab.label }}</p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel *ngFor="let tab of tabs; let i = index" [value]="i.toString()">
                <!-- <p-progressbar mode="indeterminate" [style]="{ height: '3px' }" *ngIf="!initialLoad && loading">
                </p-progressbar> -->

                <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
                    [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [loading]="initialLoad || loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.field : ''">
                                {{ col.header }}
                                <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td *ngFor="let col of columns">
                                <ng-container [ngSwitch]="col.type">
                                    <!-- Handle Number -->
                                    <ng-container *ngSwitchCase="'number'">
                                        {{ rowData[col.field] || 0 }}
                                    </ng-container>

                                    <!-- Handle Boolean -->
                                    <ng-container *ngSwitchCase="'boolean'">
                                        <i class="pi" 
                                           [ngClass]="rowData[col.field] ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'">
                                        </i>
                                    </ng-container>

                                    <!-- Handle Actions -->
                                    <ng-container *ngSwitchCase="'actions'">
                                        <p-menu [tabindex]="undefined" #menu [model]="getMenuItems(menu, rowData)"
                                            [popup]="true" appendTo="body"></p-menu>
                                        <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button"></i>
                                    </ng-container>

                                    <!-- Default Case (Normal Field) -->
                                    <ng-container *ngSwitchDefault>
                                        {{ rowData[col.field] }}
                                    </ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="loading">
                        <tr>
                            <td colspan="3" class="text-center">
                                <p-progressSpinner></p-progressSpinner>
                            </td>
                        </tr>
                    </ng-template>

                    <!-- when data length is 0 -->
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="columns.length" class="no-data">
                                <p>No records found</p>
                            </td>
                        </tr>
                    </ng-template>

                </p-table>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>

<p-dialog [modal]="true" [(visible)]="isAddPipeline" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '60vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isAddPipeline">
        <app-add-pipeline (closeDialog)="handleCloseDialog()" [pipelineType]="currentPipelineType"
            (reload)="getPipelines()">
        </app-add-pipeline>
    </ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isEditPipeline" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '60vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isEditPipeline">
        <app-add-pipeline [formAction]="'Edit'" (closeDialog)="isEditPipeline = false"
            [editPipelineData]="editPipelineData" [pipelineType]="currentPipelineType" (reload)="getPipelines()">
        </app-add-pipeline>
    </ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isDeletePipeline" [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <app-delete-pipeline [editPipelineData]="editPipelineData" (reload)="getPipelines()"
        (closeDialog)="isDeletePipeline = false"></app-delete-pipeline>
</p-dialog>
